import React, { useState } from 'react';
import { useField } from 'formik';
import DOMPurify from 'dompurify';
import classNames from 'classnames';

import Error from 'client/components/common/Error';

import css from './SchedulePopup.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label?: string;
  type: 'input' | 'textarea';
}

export const Input: React.FC<Props> = (props) => {
  const { label, name, type } = props;
  const [field, meta, helpers] = useField(name);
  const errorMsg = !!(meta.touched && meta.error) ? meta.error : '';
  const [isFocused, setIsFocused] = useState(false);

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = DOMPurify.sanitize(e.target.value);
    helpers.setValue(value);
  };

  const onBlur = (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    field.onBlur(e);
    setIsFocused(false);
  };

  const onFocus = (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    field.onBlur(e);
    setIsFocused(true);
  };

  return (
    <div className={classNames(css.inputWrap, type === 'textarea' && css.textareaWrap)}>
      {type === 'textarea' && <textarea onChange={onChange} onBlur={onBlur} onFocus={onFocus} />}
      {type === 'input' && <input onChange={onChange} onBlur={onBlur} onFocus={onFocus} />}
      {!isFocused && !field.value && <span className={css.placeholder}>{label}</span>}
      {errorMsg && meta.touched && <Error name={name} error={errorMsg} />}
    </div>
  );
};
